import React from "react"
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight"
import { PRODUCTION_STEPS_COL_WIDTHS } from "../../../../../utils/constant"
import { COLORS } from "../../../../../utils"
import { getSectionOutputsData } from "../../../../../utils/sectionUtils"
import { IconButton } from "@mui/material"
import DeleteIcon from "@mui/icons-material/Delete"
import EditIcon from "@mui/icons-material/Edit"

const SectionOutputDetails = ({ section, onEdit, onDelete, isEdition }) => {
  const sectionOutputs = getSectionOutputsData(section)
  return <>
    {sectionOutputs.length > 0 && <div className="flexRow gridBorder" style={{ background: "#F0F9FF", borderBottomWidth: "1.5px" }}>
      <div
        className="flexRow"
        style={{ width: PRODUCTION_STEPS_COL_WIDTHS[0], position: "sticky", left: 0, fontSize: 14, padding: "12px 16px 12px 80px" }}>
        <span style={{ fontWeight: 500 }}>Parties</span>
        <div style={{ marginLeft: "16px" }}>
          {sectionOutputs.map((item, index) => (
            <div key={index} className="flexRow">
              <SubdirectoryArrowRightIcon sx={{ color: "#90C9F9", fontSize: 20 }} />
              <div style={{ margin: "0 0 12px 4px" }}>
                <span style={{ fontWeight: 400 }}>{item.name}</span>
                <div style={{ color: COLORS.BLACK_500 }}>{item.value}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex1 flexRow justifyEnd" style={{ padding: "7px 25px", gap: "2px", position: "relative" }}>
        {isEdition && <div className="flexRow justifyEnd" style={{ position: "sticky", right: "25px" }}>
          <IconButton
            onClick={onEdit}
            sx={{ padding: "5px" }}
            title="Modifier la ligne"
            aria-label="Modifier la ligne"
            size="medium"
          >
            <EditIcon />
          </IconButton>
          <IconButton
            onClick={onDelete}
            sx={{ padding: "5px" }}
            title="Supprimer la ligne"
            aria-label="Supprimer la ligne"
            size="medium"
          >
            <DeleteIcon />
          </IconButton>
        </div>}
      </div>
    </div>
    }
  </>
}

export default SectionOutputDetails